import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { ToastMessage } from './toast.models';

@Component({
    selector: 'pax-toast',
    standalone: true,
    imports: [LucideAngularModule, CommonModule],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('progressBar', [
            state('start', style({ width: '100%', opacity: 1 })),
            state('end', style({ width: '0%', opacity: 0 })),
            transition('start => end', [animate('{{life}}ms linear')]),
        ]),
    ],
})
export class ToastComponent implements OnInit {
    @Input() toast!: ToastMessage;
    @Output() closeToast = new EventEmitter<string>();

    progressBarState = 'start';

    ngOnInit() {
        if (this.toast.options?.progressBar && !this.toast.options?.sticky) {
            setTimeout(() => {
                this.progressBarState = 'end';
            }, 0);
        }
    }
}
